import { TApplicationState } from '../../types/redux';

export function selectChatOnboarding(state: TApplicationState) {
  return state.chatOnboarding;
}
